import React, { FC, memo } from 'react'

import { ArtistMainInfo } from 'modules/Projects/components'
import { useArtistInfo } from 'modules/Projects/serviceHooks'

import { SkeletonArtistInfo } from 'modulesCommon/Skeleton/ProjectDetails'

import { TRouterParams } from 'shared/types'
import { isEmpty } from 'shared/utils/isEmpty'
import { useParams } from 'react-router-dom'

const ArtistInfoContainer: FC = memo(() => {
  const { id } = useParams<TRouterParams>()
  const { activeArtist, activeProject } = useArtistInfo(id)

  return !isEmpty(activeArtist) ? (
    <ArtistMainInfo
      artist={activeArtist}
      project={activeProject}
      offset={true}
    />
  ) : (
    <SkeletonArtistInfo />
  )
})

export default ArtistInfoContainer
